export default function getCurrentVersion({
  latestVersion, versions


}) {
  const version = versions.find(({ versionNumber }) => versionNumber === latestVersion);

  return version || versions[0];
}